var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoResolvr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2291,
    height: 971,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 862,
    y: 423,
    width: 2291,
    height: 971
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-862 -423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 994,
    width: 401,
    height: 400,
    fill: "#5386E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 994,
    width: 400,
    height: 400,
    fill: "#4C4B63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2019,
    y: 994,
    width: 401,
    height: 400,
    fill: "#E2A8CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2459,
    y: 994,
    width: 400,
    height: 400,
    fill: "#ABA8B2"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#4C4B63",
    fontFamily: "Corbel Light,Corbel Light_MSFontService,sans-serif",
    fontWeight: 300,
    fontSize: 422,
    transform: "matrix(1 0 0 1 1115.14 945)"
  }, "RE:SOLVR"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoResolvr);
export default __webpack_public_path__ + "static/media/logo_resolvr.6ab9c5b49df6406668020ccf0772b2ec.svg";
export { ForwardRef as ReactComponent };